import { API_URL_BACKEND, APP_ENV, RECAPTCHA_KEY } from "config";
import axios from "./helper/interceptors";
import Axios from "axios";

const cleanAxios = Axios.create();

// import { dataInspect } from "../utility/mock/inspect";

const urlBackend = API_URL_BACKEND;

const isDev = APP_ENV === "development";
// mockinference or
const pathInference = "inference";

export const checkScannerOnline = (port = "http://localhost:4000") => {
  if (isDev) {
    return new Promise((resolve) => {
      resolve();
    });
  } else {
    return new Promise((resolve, reject) => {
      fetch(port)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  }
};

// export const saveInference = (data,cancelToken) => {
//   if (isDev) {
//     return new Promise((resolve) => {
//       setTimeout(() => {
//         const res = {
//           dataInference: dataInspect,
//           inferenceID: "a_autoincrease_test",
//           request_id: "6e179705-9350-4625-b4c3-23c016eeb8da"
//         };
//         resolve({ data: res });
//       }, 4000);
//     });
//   } else {
//     return axios({
//       method: "post",
//       url: `${urlInfernec}`,
//       data: data,
//       cancelToken
//     });
//   }
// };
export const saveInferenceWhiteness = ({ imageurl, driver, featureType }, cancelToken) => {
  return axios({
    method: "post",
    url: `${urlBackend}/${pathInference}`,
    data: {
      imageurl,
      driver,
      featureType,
    },
    cancelToken,
  });
};

export const decodeQrcode = ({ imgUrl, decodeType = "scanner" }, cancelToken) => {
  return axios({
    method: "post",
    url: `${urlBackend}/decode-qrcode`,
    data: {
      image_url: imgUrl,
      decode_type: decodeType,
    },
    cancelToken,
  });
};

export const saveInference = (
  {
    imageurl,
    driver,
    yellowLevel,
    undermilledLevel,
    damagedLevel,
    chalkyLevel,
    headLevel,
    isAutoYellow,
    info,
  },
  cancelToken
) => {
  return axios({
    method: "post",
    url: `${urlBackend}/${pathInference}`,
    data: {
      imageurl,
      driver,
      yellowLevel,
      chalkyLevel,
      undermilledLevel,
      damagedLevel,
      headLevel,
      isAutoYellow,
      info,
    },
    cancelToken,
  });
};

export const checkStatusInference = ({ requestId, state, imageUrl, standardId }, cancelToken) => {
  return axios({
    method: "post",
    // url: `${urlBackend}/${pathInference}/state`,
    url: `http://localhost:8888/result`,
    data: {
      reqid: requestId,
      state: state,
      imageurl: imageUrl,
      standardID: standardId,
    },
    cancelToken,
  });
};

export const deleteInference = (requestId) => {
  return axios({
    method: "delete",
    url: `${urlBackend}/${pathInference}?reqid=${requestId}`,
  });
};

// export const sendEmailAttachmentExcel = (data) => {
//     return axios({
//       method: "post",
//       url: `${process.env.REACT_APP_API_URL_BACKEND}/sendEmailAttachmentExcel`,
//       data: data,
//     });
// };

export const sharedEmailAttachmentExcel = (data) => {
  return axios({
    method: "post",
    url: `${urlBackend}/shareListHistory`,
    data: data,
  });
};

export const sharedEmailAttachmentPDF = (data) => {
  return axios({
    method: "post",
    url: `${urlBackend}/shareHistoryPDF`,
    data: data,
  });
};

export const requestUploadImage = (cancelToken) => {
  return axios({
    method: "get",
    url: `${urlBackend}/requestUpload`,
    cancelToken,
  });
};

export const presignedMultipart = (cancelToken, action, payload) => {
  return axios({
    method: "post",
    url: `${urlBackend}/uploadMultipart`,
    data: {
      action: action,
      ...payload,
    },
    cancelToken,
  });
};

export const uploadImageMultipart = (url, blob) => {
  return cleanAxios({
    method: "PUT",
    url: url,
    data: blob,
    headers: {
      "Content-Type": "application/octet-stream",
    },
    // cancelToken,
  });
};

export const uploadImage = (uploadURL, data, cancelToken) => {
  return axios({
    method: "PUT",
    url: `${uploadURL}`,
    headers: {
      "Content-Type": "image/png",
    },
    isNotAuth: true,
    data: data,
    cancelToken,
  });
};

export const downloadFile = ({ data, accept, path, header = {}, ...option }) => {
  return axios({
    method: "POST",
    responseType: "blob",
    headers: {
      Accept: `application/${accept}`,
      ...header,
    },
    url: `${urlBackend}/${path}`,
    data: data,
    ...option,
  });
};

export const getMaintenance = () => {
  return axios({
    method: "GET",
    url: `${urlBackend}/maintain`,
    isNotAuth: true,
  });
};

/**
 *
 * @param logState
 *  1 = goto beta
 *  2 = goto normal
 */
export const sendLogAnalytic = (data) => {
  return axios({
    method: "POST",
    url: `${urlBackend}/log-analytic`,
    data: {
      ...data,
    },
  });
};

export const sendFeedback = ({ satisfied, typeFeedback, feedback }) => {
  return axios({
    method: "POST",
    url: `${urlBackend}/feedback`,
    data: {
      satisfied,
      typeFeedback,
      feedback,
    },
  });
};

export const getDashboard = ({ name, fromDate, toDate, typerice, standard, timezone }) => {
  return axios({
    method: "POST",
    url: `${urlBackend}/dashboard`,
    data: {
      scanner: name,
      fromDate,
      toDate,
      riceID: typerice,
      standardID: standard,
      timezone,
    },
  });
};

export const getNotification = () => {
  return axios({
    method: "GET",
    url: `${urlBackend}/notification`,
    // isNotCallUnAuth: true
  });
};

export const sendReadNotificatio = (id = []) => {
  return axios({
    method: "POST",
    url: `${urlBackend}/notification/read`,
    data: {
      id: id,
    },
  });
};

export const getRecentUsage = () => {
  return axios({
    method: "GET",
    url: `${urlBackend}/lasted-used`,
    isNotCallUnAuth: true,
  });
};

export const updateRecentUsage = (data) => {
  return axios({
    method: "PUT",
    url: `${urlBackend}/lasted-used`,
    data,
  });
};

export const getRiceVariety = () => {
  return axios({
    method: "GET",
    url: `${urlBackend}/rice-variety`,
  });
};

export const verifyRecaptcha = (data) => {
  return axios({
    method: "POST",
    url: `${urlBackend}/recaptcha`,
    data: {
      token: data.token,
      siteKey: RECAPTCHA_KEY,
      expectedAction: data.action,
    },
    isNotAuth: true,
  });
};

export const startScan = (reqBody) => {
  return axios({
    method: "POST",
    url: `http://localhost:8888/stream-capture/start-capture`,
    data: reqBody,
  });
};

export const stopScan = () => {
  return axios({
    method: "POST",
    url: `http://localhost:8888/stream-capture/stop-capture`,
  });
};
